export default __webpack_public_path__ + "static/gif-services-eb949635f385eb7350da95bc32f27549.gif";